import actions from './actions';

const setExtent = actions.setExtent;
const mapLoaded = actions.mapLoaded;
const setMapColumnVisible = actions.setMapColumnVisible;

export default {
  setExtent,
  mapLoaded,
  setMapColumnVisible
};



// WEBPACK FOOTER //
// ./src/redux/map/operations.js